import { PageData } from "../Definitions/UserContext";

export function SetGlobalPageList( pagelist:PageData[]){
    (window as any).sitepagedata = pagelist;

}
export function GetGlobalPageList(){

    return (window as any).sitepagedata??[];
}

export function SetGlobalCurrentPageId(id:string){

    (window as any).currentvpage = id;

}

export function SetPreviewCluster(cluster:string){

    (window as any).previewCluster = cluster;
}

export function GetPreviewCluster(){
    return (window as any).previewCluster;
}

export function GetGlobalCurrentPageId(){

    return (window as any).currentvpage??"";
}

export function SetGlobalCurrentPageData(page:PageData){
    (window as any).currentpagedata = page;
}   

export function GetGlobalCurrentPageData():PageData{
    let pg = (window as any).currentpagedata;
    if(!pg){
        pg = {name:"",url:"",pageId:"",isDisabled:false,isLandingPage:false,isHidePage:false,isDuplicateAllLocationPage:false};
    }
    return pg;
}

export function GetIsEditor(){
    return (window as any).isEditor;
}

export function SetIsEditor(isEditor:boolean){
    (window as any).isEditor = isEditor;
}